<template>
  <div class="animated fadeIn">
    <b-card class="bs-callout bs-callout-primary panelScrollBar" style="height:135px;margin-bottom:12px;margin-top:10px;">
      <!-- [start] 모델 커스터 마이징 헤더영역 -->
      <b-row style="min-width: 1200px;">
        <b-col sm="3">
          <div style="margin-top:-7px;">
            <span class="card-title wise-card-header">모델 커스터마이징</span>
          </div>
          <div class="wise-small-header">Model Customizing</div>
        </b-col>
        <b-col sm="9" class="brief">
          <b-row>
            <b-col sm="5">
              <div class="input-bottom-line">
                <b-row>
                  <b-col sm="2" class="wise-small-header wise-small-header2" style="">모델명</b-col>
                  <b-col sm="10" style="padding-left:0px">
                    <b-form-input class="no-border" :class="{error: errors.has('modelName')}" name="modelName" v-validate="'required|min:2'" v-model="formData.modelName" type="text" placeholder="모델명을 입력하세요 "></b-form-input>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row style="padding-top:10px;">
            <b-col sm="3">
              <div class="input-bottom-line">
                <b-row>
                  <b-col sm="4" class="wise-small-header wise-small-header2">광고소재</b-col>
                  <b-col sm="8" style="padding-left:0px;">
                    <select :id="selectType" class="form-control no-border " :class="{error: errors.has(selectType)}" :name="selectType" v-validate="'required'" v-model="formData.type" required>
                        <option value="" disabled selected hidden>소재</option>
                        <option v-for="(type_obj, type) in screens" :value="type">{{type}}</option>
                    </select>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col sm="3">
              <div class="input-bottom-line">
                <b-row>
                  <b-col sm="4" class="wise-small-header wise-small-header2">미디어</b-col>
                  <b-col sm="8" style="padding-left:0px;">
                    <select :id="selectMedia" class="form-control no-border" :class="{error: errors.has(selectMedia)}" :name="selectMedia" v-validate="'required'" v-model="formData.media" required>
                        <option value="" disabled selected hidden>미디어</option>
                        <option v-for="(media_obj, media) in mediass" :value="media">{{media}}</option>
                    </select>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col sm="3">
              <div class="input-bottom-line">
                <b-row>
                  <b-col sm="4" class="wise-small-header wise-small-header2">채널</b-col>
                  <b-col sm="8" style="padding-left:0px;">
                    <select :id="selectChannel" class="form-control no-border" :class="{error: errors.has(selectChannel)}" :name="selectChannel" v-validate="'required'" v-model="formData.channel" required>
                        <option value="" disabled selected hidden>채널</option>
                        <option v-for="(channel_obj, channel) in channels" :value="channel">{{channel}}</option>
                    </select>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col sm="3">
              <!-- <div class="input-bottom-line">
                <b-row>
                  <b-col sm="4" class="wise-small-header wise-small-header2">타겟</b-col>
                  <b-col sm="8" style="padding-left:0px;" v-on:click="targetModal = !targetDisabled">
                    <b-form-input class="no-border" v-model="formData.genderLabel" type="text" placeholder="타겟" v-on:focus="targetModal = !targetDisabled" :disabled="targetDisabled"></b-form-input>
                  </b-col>
                </b-row>
              </div> -->
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- [end] 모델 커스터 마이징 헤더영역 -->
    </b-card>
    <b-card class="bs-callout bs-callout-primary panelScrollBar" style="height:760px;margin-bottom:12px;">
      <resize-observer @notify="handleResize" />
      <div style="min-width: 1200px;">
        <b-row>
          <b-col sm="5">
            <b-row style="padding-bottom:35px;">
              <b-col sm="12">
                <span class="card-title wise-card-title">모델 RAW데이터 입력 </span>
              </b-col>
            </b-row>
             <b-row>
               <!-- [start] 엑셀파일 업로드 -->
               <b-col sm="6">
                 <b-row>
                   <b-col sm="12">
                     <div id="wrapper" style="height:35px;" class="input-bottom-line">
                         <input type="file" id="input-excel" style="display:none" />
                         <button id='btn-upload'>Upload</button> {{excelfileName}}
                     </div>
                   </b-col>
                 </b-row>
                 <b-row style="margin-top:20px;">
                   <b-col sm="12">
                     <div>
                       <table   id="rowDatatable"
                                data-search="false"
                                data-show-columns="false"
                                data-pagination="false"
                                data-detail-view="false"
                                data-detail-formatter="detailFormatter"
                                >
                            <thead>
                                <tr>
                                    <th data-field="index">연번</th>
                                    <th data-field="grps">GRPs</th>
                                    <th data-field="reach1">Reach(%)</th>
                                </tr>
                            </thead>
                        </table>
                     </div>
                   </b-col>
                 </b-row>
               </b-col>
               <!-- [end] 엑셀파일 업로드 -->
               <!-- [start] 기본 통계 정보 및 예측 모델 생성 -->
               <b-col sm="6" >
                 <b-row>
                   <b-col sm="12">
                     <div style="height:35px;"  class="input-bottom-line">
                       <span style="vertical-align:middle">
                         <b>기본 통계 정보</b>
                       </span>
                     </div>
                   </b-col>
                 </b-row>
                 <b-row style="margin-top:20px;">
                   <b-col sm="12">
                     <div>
                       <table class="table">
                        <tr>
                          <td>GRPs Mean</td>
                          <td>{{grpsMean}}</td>
                        </tr>
                        <tr>
                          <td>GRPs Min</td>
                          <td>{{grpsMin}}</td>
                        </tr>
                        <tr>
                          <td>GRPS Max</td>
                          <td>{{grpsMax}}</td>
                        </tr>
                        <tr>
                          <td>Reach Mean</td>
                          <td>{{reachMean}}</td>
                        </tr>
                        <tr>
                          <td>Reach Min</td>
                          <td>{{reachMin}}</td>
                        </tr>
                        <tr>
                          <td>Reach Max</td>
                          <td>{{reachMax}}</td>
                        </tr>
                      </table>
                     </div>
                   </b-col>
                 </b-row>
                 <b-row>
                   <b-col sm="12">
                     <div>
                       <b-button block variant="outline-primary" class="btn-pill" @click="goResult">
                         <span style="font-weight:900;">예측모델 생성</span>
                       </b-button>
                     </div>
                   </b-col>
                 </b-row>
                 <b-row style="margin-top:20px;">
                   <b-col sm="12">
                      <b-card class="text-white bg-secondary">
                        <p>※ 주의</p>
                        <p>예측모델 커스터마이징 데이터 입력 시 RAW 데이터가 최소 30개  이상입력 할 것.</p>
                        <p>데이터수가 많을 수록 예측모델의 정확도가 향상됩니다.</p>
                      </b-card>
                   </b-col>
                 </b-row>
               </b-col>
               <!-- [end] 기본 통계 정보 및 예측 모델 생성 -->
             </b-row>
          </b-col>
          <b-col sm="7" class="brief">
            <b-row style="padding-bottom:35px;">
              <b-col sm="12">
                <span class="card-title wise-card-title">Model Reach Curve Overview</span>
              </b-col>
            </b-row>
            <div v-show="showOverview">
              <b-row>
                <b-col sm="12">
                  <!-- [start] 리미트 조절 -->
                  <b-row>
                    <b-col sm="1" class="wise-small-header wise-small-header2" style="">Limit_1</b-col>
                    <b-col sm="2" style="padding-left:0px">
                      <b-form-input min1 max=100 v-model="limit_1" @keyup.native="limit_1_ValueCheck()" type="number"></b-form-input>
                    </b-col>
                    <b-col sm="1" class="wise-small-header wise-small-header2" style="">Limit_2</b-col>
                    <b-col sm="2" style="padding-left:0px">
                      <b-form-input min=1 max=100 v-model="limit_2" @keyup.native="limit_2_ValueCheck()" type="number"></b-form-input>
                    </b-col>
                  </b-row>
                  <!-- [end] 리미트 조절 -->
                </b-col>
              </b-row>
              <b-row style="margin-top:20px;">
                <!-- [start] 차트 그리기 -->
                <b-col sm="12">
                  <div id="modelcustomChartdiv" class="CSSAnimationChart"></div>
                  <div class="input-bottom-line">
                  </div>
                </b-col>
                <!-- [end] 차트 그리기 -->
              </b-row>
              <b-row style="margin-top:20px;">
                <b-col sm="12">
                  <b-row>
                    <!-- [start] 모델 테스트(시뮬레이션) -->
                    <b-col sm="4">
                      <b-col sm="12">
                        <div style="margin-bottom:15px;text-align:center;padding:5px 0px 5px 0px;" class="bg-primary">
                          <b>모델 테스트(Reach)</b>
                        </div>
                      </b-col>
                      <b-col sm="12">
                        <b-row>
                          <b-col sm="6">
                            <select class="form-control" v-model="selectedGRPs">
                                <option value="grps" selected>GRPs</option>
                                <option value="impression">Impression</option>
                            </select>
                          </b-col>
                          <b-col sm="6">
                            <div class="modelTestLabel">
                              Reach 1+(%)
                            </div>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col sm="12">
                        <b-row>
                          <b-col sm="6">
                            <b-form-input class="bg-light" min=0 v-model="insertedGRPsStr" type="text" ></b-form-input>
                          </b-col>
                          <b-col sm="6">
                            <div class="bg-light modelTestLabel">
                              {{testReach}}
                            </div>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-col>
                    <b-col sm="8">
                      <b-col sm="12">
                        <div style="margin-bottom:15px;text-align:center;padding:5px 0px 5px 0px;" class="bg-primary">
                          <b>모델 세부 테스트(금액)</b>
                        </div>
                      </b-col>
                      <b-col sm="12">
                        <b-row>
                          <b-col sm="3">
                            <select class="form-control" v-model="selectedReach">
                                <option value="reach" selected>Reach</option>
                                <option value="reachN">도달자 수</option>
                            </select>
                          </b-col>
                          <b-col sm="3">
                            <div class="modelTestLabel">
                              필요 GRPs
                            </div>
                          </b-col>
                          <b-col sm="2" style="padding-right:0px;">
                            <select class="form-control" v-model="selectedCPM">
                                <option value="cpm" selected>CPM</option>
                                <option value="cprp">CPRP</option>
                            </select>
                          </b-col>
                          <b-col sm="4">
                            <div class="modelTestLabel">
                              필요금액
                            </div>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col sm="12">
                        <b-row>
                          <b-col sm="3">
                            <b-form-input class="bg-light" min=0 v-model="insertedReachStr" type="text" ></b-form-input>
                          </b-col>
                          <b-col sm="3">
                            <div class="bg-light modelTestLabel">
                              {{testGRPs}}
                            </div>
                          </b-col>
                          <b-col sm="2" style="padding-right:0px;">
                            <b-form-input class="bg-light" min=0 v-model="insertedCPMStr" type="text" ></b-form-input>
                          </b-col>
                          <b-col sm="4">
                            <div class="bg-light modelTestLabel">
                              {{testBudget}}
                            </div>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-col>
                    <!-- [end] 모델 테스트(시뮬레이션) -->
                  </b-row>
                </b-col>
              </b-row>
              <b-row style="margin-top:20px;">
                <!-- [start] 모델 저장 -->
                <b-col sm="12">
                  <b-button block variant="outline-primary" class="btn-pill" @click="modelSave">
                    <span style="font-weight:900;">예측모델 저장</span>
                  </b-button>
                </b-col>
                <!-- [end] 모델 저장 -->
              </b-row>
              <b-row style="margin-top:20px;">
                <b-col sm="12">
                  <b-card class="text-white bg-secondary">
                    <p>예측모델 저장 후 <b>동일한 미디어, 채널, 타겟설정의 라인 설정</b>시 예측모델 커스터마이징한 모델을 확인 할 수 있습니다.</p>
                  </b-card>
                </b-col>
              </b-row>
            </div>
            <div v-show="!showOverview">
              <b-row>
                <b-col sm="12">
                  <div style="font-size:18px;font-weight:600;color:#cccccc">
                    <p>1. 모델 raw 데이터를 입력하세요.</p>
                    <p>2. 기본 통계 정보 확인후 '예측모델 생성' 버튼을 클릭하세요.</p>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal title="목표 타겟 설정" size="lg" v-model="targetModal" @ok="targetModal = false">
      <reachTarget v-bind:formData="formData" ref="reachTargetRef"></reachTarget>
    </b-modal>
  </div>
</template>
<style src="bootstrap-table/dist/bootstrap-table.min.css"></style>

<script>
import Vue from 'vue';
const moment = require("moment");
import XLSX from "xlsx/dist/xlsx.full.min.js";
import modelFormData from "../common/ModelFormData.js";
import reachTarget from "../common/reachTarget.vue"
import leftSideUtil from "../common/LeftSideUtil.js"
import math from "mathjs"
import bootstrapTable from "bootstrap-table";
import numeral from 'numeral';
import swal from 'sweetalert2';

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
import VueResize from 'vue-resize'
Vue.use(VueResize)

import amchart from "../../custom/amcharts/amcharts.js";
import serial from "../../custom/amcharts/serial.js";
import modelCustomChart from "./modelCustomChart.js";

export default {
  name: 'modelCustomizing',
  components: {
    reachTarget
  },
  data(){
    return {
      id: null,
      showOverview: false,
      excelLoaded:false,
      formData: this.$_.clone(modelFormData.formData),
      screens: modelFormData.ScreenMediaStructure_B,
      mediass: [],
      channels: [],
      demographics: null,
      targetModal: false,
      selectType: 'selectType',
      selectMedia: 'selectMedia',
      selectChannel: 'selectChannel',
      targetDisabled: true,
      rowDataArr: [],
      excelfileName: '파일을 선택 하세요.',
      //[ start 계수 계산 변수]/////////////////////////////////////////
      limit_1 : 100,
      limit_2 : 100,
      grpsArr: [],
      reachArr: [],
      grpsMean: 0.0,
      grpsMin: 0.0,
      grpsMax: 0.0,
      reachMean: 0.0,
      reachMin: 0.0,
      reachMax: 0.0,
      ln_grps_i: 0.0,
      odds_r1_i: 0.0,
      sx_i: 0.0,
      sy_i: 0.0,
      sxx_i: 0.0,
      sxy_i: 0.0,
      B: 0.0,
      A: 0.0,
      ln_grps_arr: [],
      odd_r1_arr: [],
      odd_r1_arr_clean:[],
      sx_arr: [],
      sy_arr: [],
      sxx_arr: [],
      sxy_arr: [],
      //[ end 계수 계산 변수]/////////////////////////////////////////
      //[ start 계수 계산 결과]/////////////////////////////////////////
      constCffnt : {},
      resultCffnt : {},
      // max_arr: [],
      //[ end 계수 계산 결과]/////////////////////////////////////////
      //[ start 모델 테스트 변수]/////////////////////////////////////////
      selectedGRPs:'grps',
      selectedReach:'reach',
      selectedCPM: 'cpm',
      insertedGRPsStr: 0,
      insertedGRPs:0,
      insertedReachStr: 0,
      insertedReach:0,
      insertedCPMStr: 0,
      insertedCPM:0,
      testReach:0.0,
      testGRPs:0.0,
      testBudget:0,
      //[ end 모델 테스트 변수]/////////////////////////////////////////
      json: [],
      sortRowDataArr: [], // 차트용 데이터
    }
  },
  watch: {
    'limit_1' : function(){
      this.resultCffnt = this.makeResult(this.limit_1, this.limit_2);
      this.chageLimit();
      this.calcInsertedGRPs();
      this.calcInsertedReach();
      this.calcInsertedCPM();
    },
    'limit_2' : function(){
      this.resultCffnt = this.makeResult(this.limit_1, this.limit_2);
      this.chageLimit();
      this.calcInsertedGRPs();
      this.calcInsertedReach();
      this.calcInsertedCPM();
    },
    //[ start 매체 캐스캐이딩]/////////////////////////////////////////
    'formData.type' : function(){
      this.formData.media = '';
      this.formData.channel = '';
      this.mediass = this.screens[this.formData.type];
    },
    'formData.media': function() {
      if(this.formData.media === ''){
        this.formData.channel = '';
      }else{
        this.formData.channel = '전체';
      }
      this.channels = [];
      if (this.formData.media.length > 0) {
        this.channels = this.mediass[this.formData.media];
      }
      if(this.formData.media == 'TV'){
        // this.targetDisabled = true;
        // this.$refs.reachTargetRef.disableTarget();
      }else{
        // this.targetDisabled = false;
      }
    },
    // 'formData.channel': function() {
    //   if(this.formData.channel == 'SMR'){
    //     this.targetDisabled = true;
    //     this.$refs.reachTargetRef.disableTarget();
    //   }else if(this.formData.media == 'TV'){
    //     this.targetDisabled = true;
    //     this.$refs.reachTargetRef.disableTarget();
    //   }else{
    //     this.targetDisabled = false;
    //   }
    // },
    //[ end 매체 캐스캐이딩]/////////////////////////////////////////
    //[ start 모델테스트 watch]/////////////////////////////////////////
    'insertedGRPsStr': function(){
      this.calcInsertedGRPs();
    },
    'insertedReachStr': function(){
      this.calcInsertedReach();
      this.calcInsertedCPM();
    },
    'insertedCPMStr': function(){
      this.calcInsertedCPM();
    },
    'selectedGRPs': function(){
      this.calcInsertedGRPs();
    },
    'selectedReach': function(){
      this.calcInsertedReach();
      this.calcInsertedCPM();
    },
    'selectedCPM': function(){
      this.calcInsertedCPM();
    }
    //[ end 모델테스트 watch]/////////////////////////////////////////
  },
  created: function() {
  },
  mounted: function() {
    leftSideUtil.highLightMenu('modelCustomId8642');
    var self = this;
    self.makeTable(); // 빈껍데기 테이블을 표현하기위해서 엑셀로딩전에 먼저 한번 실행
    setTimeout(function(){
      self.$refs.reachTargetRef.demographicCount(); // 타겟 모수 계산
    }, 1000); // 1초후 실행

    this.getScreenChannel('VA', 'TV');
    this.getScreenChannel('VA', 'PC');
    this.getScreenChannel('VA', 'Mobile');
    this.getScreenChannel('VA', 'Digital');
    // this.getScreenChannel('DA', 'Digital') // 2019.05.09 DA에서 Digital은 배너사이즈 측정 문제로 보류
    this.getScreenChannel('DA', 'PC');
    this.getScreenChannel('DA', 'Mobile');

    $('#btn-upload').click(function(e){
        e.preventDefault();
        $('#input-excel').click();}
    );
    var self = this;
    $('#input-excel').change(function(e){
                var reader = new FileReader();
                reader.readAsArrayBuffer(e.target.files[0]);
                self.excelfileName = e.target.files[0].name
                reader.onload = function(e) {
                  self.showOverview = false;
                  var data = new Uint8Array(reader.result);

                  var workbook = XLSX.read(data, {type:"array"});
                  var first_sheet_name = workbook.SheetNames[0]; // 엑셀 첫번째 sheet 네임 읽기
                  var worksheet = workbook.Sheets[first_sheet_name];
                  self.json = XLSX.utils.sheet_to_json(worksheet,{raw:true}); // 엑셀 데이터 배열에 담기
                  self.constCffnt = self.makeResult(100, 100); // 리미트를 100으로 고정한 차트를 그릴 데이터 구하기
                  self.resultCffnt = self.makeResult(self.limit_1, self.limit_2); // 사용자가 지정한 리미트로 차트를 그릴 데이터 구하기
                  self.excelLoaded = true;
                  self.makeTable();
                }
            });
  },
  methods: {
    modelSave(){ // 서버로 모델을 저장하는 코드
      this.$validator.validateAll().then(res => {
        if(res){
            // [start] DB에 저장히기 위한 데이터 만들기
            var formData = this.$_.clone(this.resultCffnt);
            formData.A = formData.a;
            formData.B1 = formData.b1;
            formData.LMT = formData.lmt;
            formData.user_id = this.$session.get('email');
            formData.std_dt = moment().format('YYYY-MM-DD HH:mm');
            formData.media_type = this.formData.type;
            formData.level = 'Vehicle Level';
            formData.media = this.formData.media;
            formData.channel = this.formData.channel;
            formData.vehicle = this.formData.modelName;
            formData.cffcnt_model = '1차';
            formData.target = this.formData.targetCode;
            // [end] DB에 저장히기 위한 데이터 만들기

            if(formData.channel == '전체'){
              swal({
                type: 'error',
                text: "채널을선택해야합니다."
              })
              return;
            }

            var token = sessionStorage.getItem("myToken");
            var param = encodeURI(JSON.stringify(formData));

            var data = new FormData();
            data.append('objs', param);
            var config = {
              onUploadProgress: function(progressEvent) {
                var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
              }
            };

            this.$http.post('/api/insert/custommodel?access_token='+token, data,config)
            .then((result) => {
              if(result.data == 'ok'){
                console.log('모델저장 성공 !!! : ' + result.data);
                swal({
                  type: 'success',
                  // title: 'Oops...',
                  text: "사용자 모델을 저장하였습니다."
                })
                setTimeout(function(){
                  sessionStorage.setItem("modelReload", "insert");
                }, 500);
              }else if(result.data == 'duplicate'){
                console.log('모델중복 : ' + result.data);
                swal({
                  type: 'error',
                  // title: 'Oops...',
                  text: "기존에 저장되어 있는 모델 입니다."
                })
              }
            })
        }else{
          swal({
            type: 'error',
            // title: 'Oops...',
            text: "모델 기본정보를 확인해 주세요."
          })
        }
      });
    },
    calcInsertedGRPs(){ // 모델 테스트
      if(this.selectedGRPs == 'grps'){

        this.insertedGRPs = numeral(this.insertedGRPsStr).format('0.00');

        var TA = -1 * (Math.log(this.insertedGRPs) * this.resultCffnt.b1 + this.resultCffnt.a);
        var AA = 1 + Math.exp(TA);
        this.testReach = this.resultCffnt.lmt / AA * 100;
        this.testReach = this.testReach.toFixed(2);
      }else{

        this.insertedGRPsStr = numeral(this.insertedGRPsStr).format('0,0');
        this.insertedGRPs = numeral(this.insertedGRPsStr).format('0');

        var TA = -1 * (Math.log(this.insertedGRPs / this.resultCffnt.population * 100) * this.resultCffnt.b1 + this.resultCffnt.a);
        var AA = 1 + Math.exp(TA);
        this.testReach = this.resultCffnt.lmt / AA * 100;
        this.testReach = this.testReach.toFixed(2);
      }
    },
    calcInsertedReach(){ // 모델 테스트
      if(this.selectedReach == 'reach'){

        this.insertedReach = numeral(this.insertedReachStr).format('0.00');

        var reach = this.insertedReach / 100;
        var TA = this.resultCffnt.lmt/reach - 1;
        var AA = Math.log((TA))
        var BB = -1 * (this.resultCffnt.a + AA);
        var CC = Math.exp(BB/this.resultCffnt.b1);
        this.testGRPs = CC.toFixed(2);
      }else{
        this.insertedReachStr = numeral(this.insertedReachStr).format('0,0');
        this.insertedReach = numeral(this.insertedReachStr).format('0');

        var reach = this.insertedReach / this.resultCffnt.population;
        var TA = this.resultCffnt.lmt/reach - 1;
        var AA = Math.log((TA))
        var BB = -1 * (this.resultCffnt.a + AA);
        var CC = Math.exp(BB/this.resultCffnt.b1);
        this.testGRPs = CC.toFixed(2);
      }
    },
    calcInsertedCPM(){ // 모델 테스트
      this.insertedCPMStr = numeral(this.insertedCPMStr).format('0,0');
      this.insertedCPM = numeral(this.insertedCPMStr).format('0');
      if(this.selectedCPM == 'cpm'){
        this.testBudget = (this.testGRPs/100 * this.resultCffnt.population)/1000 * this.insertedCPM;
        this.testBudget = numeral(this.testBudget).format('0,0');
      }else{
        this.testBudget = this.testGRPs * this.insertedCPM
        this.testBudget = numeral(this.testBudget).format('0,0');
      }
    },
    goResult(){ // 결과 생성 (차트그리기)
      if(!this.showOverview&&this.excelLoaded){
        this.makeReach();
        modelCustomChart.drawChart(this.sortRowDataArr);
        this.showOverview = true;
      }
    },
    chageLimit(){
      if(this.showOverview){
        this.makeReach();
        modelCustomChart.drawChart(this.sortRowDataArr);
      }
    },
    limit_1_ValueCheck(){ // 리미트값 검증
      if(this.limit_1 > 100){
        this.limit_1 = 100
      }else if(this.limit_1 < 1){
        this.limit_1 = 1
      }
    },
    limit_2_ValueCheck(){ // 리미트값 검증
      if(this.limit_2 > 100){
        this.limit_2 = 100
      }else if(this.limit_2 < 1){
        this.limit_2 = 1
      }
    },
    dataInit(){ // 데이터 초기화
      this.rowDataArr = [];
      this.grpsArr = [];
      this.reachArr = [];
      this.ln_grps_arr = [];
      this.odd_r1_arr = [];
      this.odd_r1_arr_clean = [];
      this.sx_arr = [];
      this.sy_arr = [];
      this.sxx_arr = [];
      this.sxy_arr = [];
    },
    makeResult(limit_1, limit_2){ // 차트에 그릴 데이터 및 평균 값들 구하기
      this.dataInit();

      for(var i=0; i<this.json.length; i++){
        var grps_i = this.json[i].GRPS;
        var reach_i = this.json[i].Reach;
        var lowData = {}
        lowData.index = i+1;
        lowData.grps = grps_i;
        lowData.reach1 = reach_i;
        this.rowDataArr.push(lowData);

        this.grpsArr.push(grps_i);
        this.reachArr.push(reach_i);

        ///////////////////////////////////////////////////////
        this.grpsMean = math.mean(this.grpsArr).toFixed(4);
        this.grpsMin = math.min(this.grpsArr).toFixed(4);
        this.grpsMax = math.max(this.grpsArr).toFixed(4);
        this.reachMean = math.mean(this.reachArr).toFixed(4);
        this.reachMin = math.min(this.reachArr).toFixed(4);
        this.reachMax = math.max(this.reachArr).toFixed(4);
        /////////////////////////////////////
        this.ln_grps_arr.push(Math.log(grps_i));
        /////////////////////////////////////
        if(reach_i > limit_1){
          this.odd_r1_arr.push(null);
        }else{
          var odds_r1 = Math.log(((reach_i/100) / (limit_1/100 - reach_i/100)));
          if(isFinite(odds_r1)){
            this.odd_r1_arr.push(odds_r1);
            this.odd_r1_arr_clean.push(odds_r1)
          }else{
            this.odd_r1_arr.push(null);
          }
        }
        /////////////////////////////////////
      }

      for(var i=0; i<this.json.length; i++){
        var grps_i = this.json[i].GRPS;
        var reach_i = this.json[i].Reach;
        ///////////////////////////////////////////////////////
        if(Math.log(grps_i) > 0){
          var sx_i = Math.log(grps_i) - math.mean(this.ln_grps_arr);
          this.sx_arr.push(sx_i);
        }else{
          this.sx_arr.push(null);
        }
        ///////////////////////////////////////////////////////
        if(!Math.log(grps_i) > 0 || this.odd_r1_arr[i] == null){
          this.sy_arr.push(null);
        }else{
          var sy_i = this.odd_r1_arr[i] - math.mean(this.odd_r1_arr_clean);
          this.sy_arr.push(sy_i);
        }
        ///////////////////////////////////////////////////////
        if(this.sx_arr[i] != null ){
          this.sxx_arr.push(this.sx_arr[i] * this.sx_arr[i]);
        }else{
        }

        if(this.sy_arr[i] != null && this.sx_arr[i] != null ){
          this.sxy_arr.push(this.sy_arr[i]  * this.sx_arr[i]);
        }else{
        }
      }

      this.B = math.sum(this.sxy_arr) / math.sum(this.sxx_arr);
      this.A = math.mean(this.odd_r1_arr_clean) - this.B * math.mean(this.ln_grps_arr);
      var resultCffnt = {};
      resultCffnt.a = this.A;
      resultCffnt.b1 = this.B;
      resultCffnt.lmt = limit_2 * 0.01;
      resultCffnt.population = this.formData.demographic_cnt;

      return resultCffnt;
    },
    makeReach(){ // 차트에 표현하기 위해 데이터 합치기
      for(var i=0; i < this.grpsMax; i++){
        var lowData = {};
        lowData.grps = i;
        lowData.constReach1 = this.inputLevelCalc(this.constCffnt, i);
        lowData.estReach1 = this.inputLevelCalc(this.resultCffnt, i);
        this.rowDataArr.push(lowData);
      }
      this.sortRowDataArr = this.$_.sortBy(this.rowDataArr, 'grps');
    },
    inputLevelCalc(cffcnt, grps){ // 공통파일로 대체 필요
      var z = (
        cffcnt.a +
        cffcnt.b1 * Math.log(grps)
      );
      var z2 = 1 + Math.exp(-z);
      var result = (cffcnt.lmt/z2) * 100;
      if(isNaN(result)){ // 여기에 넣기에는 너무 부담스럽지 않을까?
        result = 0;
      }
      return result;
    },
    handleResize() {
      $('#rowDatatable').bootstrapTable('resetView');
    },
    makeTable(){
      $('#rowDatatable').bootstrapTable('destroy');
      var self = this;
      $('#rowDatatable').bootstrapTable({
          height : 590,
          data: self.rowDataArr,
      });
    },
    getScreenChannel(type, media) {
      var user_id = this.$session.get('email');
      this.$http.get('/select/screenchannel?type=' + type + '&media=' + media)
        .then((result) => {
          for(var i=0; i<result.data.length; i++){
              this.screens[type][media][result.data[i].channel] = [];
              this.$http.get('/select/screenvehicle?type=' + type + '&media=' + media + '&channel=' + result.data[i].channel + '&user_id='+user_id)
                .then((resultV) => {
                  this.screens[type][media][resultV.data[0].channel] = resultV.data;
              })
          }
        })
    },
  }
}
</script>
<style src="../../custom/amcharts/amchart_plugins.min.css"></style>
<style scoped>
input.error {
  color: #9F3A38 !important;
  background-color: #FFF6F6 !important;
  border-color: #E0B4B4;
}
.form-control:disabled, .form-control[readonly] {
    /* background: #dddddd; */
    border-radius: 25px;
    background: #ECF0F1;
}
.CSSAnimationChart,
.mapChart {
    width: 100%;
    height: 300px !important
}
.modelTestLabel {
  margin-bottom:5px;
  padding:6px 0px 6px 4px;
  font-weight:600;
  color:black;
  border: 1px solid #c2cfd6;
}
</style>



// WEBPACK FOOTER //
// src/views/modelCustom/modelCustom.vue